import styled from '../../../theme'
import Button from '../Button'

const PremiumButton = styled(Button)`
  height: 38px;
  margin: 0 15px;
  max-width: 222px;
  min-height: unset;
`
export default PremiumButton
